import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { ResidentialService } from '../services/residential.service';

@Injectable()
export class ResidentialResolver  {

  constructor(private resService: ResidentialService) {}

  resolve() {
    return this.resService.getFormData('residential')
      .pipe(map(result => result));
  }
}
